<script setup></script>

<template>
  <div class="px-2">/</div>
</template>
